<div class="acc-header" (click)="toggle()">
  <div class="headerTitle">
    {{ title }}
  </div>
  <div [@rotatedState]="!showBody ? 'default' : 'rotated'" class="arrow"><i class="ion-ios-arrow-down"></i></div>
</div>
<div [@smoothCollapse]="!showBody ? 'initial' : 'final'">
  <div class="acc-body">
    <ng-content></ng-content>
  </div>
</div>
